import { render } from "./ResetPass.vue?vue&type=template&id=952ab22c&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"

import "./ResetPass.vue?vue&type=style&index=0&id=952ab22c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952ab22c"]])

export default __exports__